function handleAddButtonClick(card) {
  card.classList.toggle("active");
  const variantId = card.getAttribute("data-variant-id");
  const priceElement = card.querySelector(".product-price-current");
  const saleElement = card.querySelector(".product-price-sale");
  const addButton = card.querySelector(".add-btn");

  if (card.classList.contains("active")) {
    if (addButton) {
      addButton.classList.add("rotated");
    }
    // Update price display immediately
    if (saleElement) {
      saleElement.textContent = "";
    }
    if (priceElement) {
      if (document.querySelector(".dev-featured-collection")) {
        priceElement.innerHTML =
          "<div class='product-price-current--added'>Added to cart</div>";
        card.querySelector(".product-bottom").style.justifyContent = "center";
      } else {
        priceElement.textContent = "In Cart";
      }
    }
    addProductToCart(variantId);
  } else {
    if (addButton) {
      addButton.classList.remove("rotated");
    }
    // Restore original price immediately
    if (priceElement) {
      const originalPrice = card.getAttribute("data-original-price");
      priceElement.textContent = originalPrice;
    }
    if (saleElement) {
      const originalComparePrice = card.getAttribute(
        "data-original-compare-price"
      );
      saleElement.textContent = originalComparePrice || "";
    }
    if (document.querySelector(".dev-featured-collection")) {
      card.querySelector(".product-bottom").style.justifyContent =
        "space-between";
    }
    deleteProductCard(variantId);
  }
}

function addListenerToAddButtons() {
  document.querySelectorAll(".add-btn").forEach((button) => {
    console.log("button", button);
    button.addEventListener("click", function () {
      const card = this.closest(".product-card");
      handleAddButtonClick(card);
    });
  });

  // Add click handler for add-btn-badge
  document.querySelectorAll(".add-btn-badge").forEach((badge) => {
    badge.addEventListener("click", function () {
      const card = this.closest(".product-card");
      if (card) {
        handleAddButtonClick(card);
      }
    });
  });
}

function recalcDevCartSlider() {
  if (!document.querySelector(".dev-featured-collection")) return;
  const wrapper = document.querySelector(".cart-products-wrapper");
  const visibleItems = Array.from(
    document.querySelectorAll(".cart-product")
  ).filter((p) => p.style.display !== "none");
  if (!wrapper || visibleItems.length === 0) return;
  const first = visibleItems[0].getBoundingClientRect();
  let step = first.width;
  if (visibleItems.length > 1) {
    const second = visibleItems[1].getBoundingClientRect();
    const dx = second.left - first.left;
    step = Math.round(dx > 0 ? dx : first.width);
  }
  const perPage = Math.max(1, Math.floor(wrapper.clientWidth / step));
  const maxIndex = Math.max(0, visibleItems.length - perPage);
  currentIndex = Math.min(currentIndex, maxIndex);
  productsWrapper.style.transform = `translateX(-${currentIndex * step}px)`;
  if (!isMobile && visibleItems.length > perPage) {
    rightArrow.style.display = "flex";
    leftArrow.style.display = "flex";
  } else {
    rightArrow.style.display = "none";
    leftArrow.style.display = "none";
  }
  rightArrow.onclick = () => {
    if (currentIndex < maxIndex) {
      currentIndex++;
      productsWrapper.style.transform = `translateX(-${currentIndex * step}px)`;
    }
  };
  leftArrow.onclick = () => {
    if (currentIndex > 0) {
      currentIndex--;
      productsWrapper.style.transform = `translateX(-${currentIndex * step}px)`;
    }
  };
}

function filterProductsByTag(tag) {
  let activeCount = 0;
  document.querySelectorAll(".product-card").forEach((card) => {
    const productTags = card.getAttribute("data-product-tags").split(", ");
    if (productTags.includes(tag)) {
      card.style.display = "flex";
      activeCount++;
    } else {
      card.style.display = "none";
    }
  });
  const classesNumberElement = document.querySelector(".classes-number");
  classesNumberElement.innerHTML = `${activeCount} classes`;
}

document.querySelectorAll(".tag").forEach((tag) => {
  tag.addEventListener("click", function () {
    document.querySelectorAll(".tag").forEach((otherTag) => {
      otherTag.classList.remove("active");
    });
    this.classList.toggle("active");
    const selectedTag = this.getAttribute("data-tag");
    filterProductsByTag(selectedTag);
  });
});

function selectDefaultTag(tag) {
  document.querySelectorAll(".tag").forEach((otherTag) => {
    otherTag.classList.remove("active");
  });
  const firstTag = document.querySelector(`.tag[data-tag="${tag}"]`);
  if (firstTag) {
    firstTag.classList.add("active");
    filterProductsByTag(tag);
  }
}

// Call the function to select the default tag
selectDefaultTag("Drone Classes");

function animateAndRemoveProduct(variantId) {
  const productElements = document.querySelectorAll(".cart-product");
  productElements.forEach((product) => {
    const closeButton = product.querySelector(".close-btn");
    if (
      closeButton &&
      closeButton.getAttribute("data-variant-id") === variantId
    ) {
      product.style.transition = "opacity 1s";
      product.style.opacity = "0";
    }
  });
}

function deleteProductCard(variantId) {
  fetch(`/cart/change.js`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 0,
    }),
  })
    .then((response) => response.json())
    .then((cart) => {
      animateAndRemoveProduct(variantId);
      setTimeout(() => {
        const cartUpdatedEvent = new Event("cartUpdated");
        document.dispatchEvent(cartUpdatedEvent);
      }, 800);
    });
}

function addProductToCart(variantId) {
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      items: [
        {
          id: variantId,
          quantity: 1,
        },
      ],
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log("Product added to cart:", data);
      window.isMoreClassesShown = false;
      const event = new CustomEvent("cartUpdated", {
        detail: { productAdded: variantId },
      });
      document.dispatchEvent(event);
    })
    .catch((error) => {
      console.error("Error adding product to cart:", error);
    });
}

function loadCart() {
  return fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      console.log("Cart loaded:", cart);
      return cart; // Return the cart data
    });
}

function addMultipleProductsToCart(products) {
  loadCart().then((cart) => {
    const itemsToAdd = products
      .filter(
        (variantId) => !cart.items.some((item) => item.variant_id == variantId)
      )
      .map((variantId) => ({ id: variantId, quantity: 1 }));

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items: itemsToAdd }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Products added to cart:", data);
        window.isMoreClassesShown = false;
        if (data.items.length > 0) {
          selectDefaultTag(data.items[0].product_type);
        }
        const event = new CustomEvent("cartUpdated", {
          detail: { productsAdded: products },
        });
        document.dispatchEvent(event);
      })
      .catch((error) => {
        console.error("Error adding products to cart:", error);
      });
  });
}

const productsWrapper = document.querySelector(".cart-products");
const products = document.querySelectorAll(".cart-product");
const leftArrow = document.querySelector(".left-arrow");
const rightArrow = document.querySelector(".right-arrow");
const hideBtn = document.querySelector(".hide-items-btn");
let isMobile = false;
function checkMobile() {
  isMobile = window.innerWidth <= 768;
}

window.addEventListener("resize", () => {
  checkMobile();
  recalcDevCartSlider();
});

checkMobile();

let currentIndex = 0;
const itemsPerPage = 5;
window.isMoreClassesShown = false;

function toggleHideBtn() {
  if (window.innerWidth < 768) {
    hideBtn.style.display = "none";
  } else if (products.length > itemsPerPage) {
    hideBtn.style.display = "flex";
  } else {
    hideBtn.style.display = "none";
  }
}

toggleHideBtn();

window.addEventListener("resize", toggleHideBtn);

function updateSliderArrows() {
  const visibleProducts = Array.from(
    document.querySelectorAll(".cart-product")
  ).filter((product) => product.style.display !== "none");
  if (!isMobile) {
    if (visibleProducts.length > 5) {
      rightArrow.style.display = "flex";
      leftArrow.style.display = "flex";
    } else {
      rightArrow.style.display = "none";
      leftArrow.style.display = "none";
    }

    rightArrow.addEventListener("click", () => {
      if (
        currentIndex <
        document.querySelectorAll(".cart-product").length - itemsPerPage
      ) {
        currentIndex++;
        updateSlider();
      }
    });

    leftArrow.addEventListener("click", () => {
      if (currentIndex > 0) {
        currentIndex--;
        updateSlider();
      }
    });
  }
}

updateSliderArrows();

function updateSlider() {
  const productWidth =
    document.querySelectorAll(".cart-product")[0].offsetWidth + 24;
  productsWrapper.style.transform = `translateX(-${
    currentIndex * productWidth
  }px)`;
}

document.querySelector(".close-mobile-info").addEventListener("click", () => {
  document.querySelector(".mobile-info-wrapper").classList.remove("active");
  document.querySelector(".cart-products-wrapper").classList.remove("active");
  document.querySelector(".cart-products").style.flexWrap = "nowrap";
  document.querySelector(".more-classes").style.display = "flex";
  window.isMoreClassesShown = false;
  // Restore body scroll when closing mobile view
  document.body.style.overflow = "";

  const moreClassesButton = document.querySelector(".more-classes");
  moreClassesButton.style.display = "flex";
  const cartProducts = document.querySelectorAll(".cart-product");
  cartProducts.forEach((product, index) => {
    if (index !== cartProducts.length - 1) {
      product.style.display = "none";
    }
  });
});

function showMoreClasses(cart) {
  const moreClassesButton = document.querySelector(".more-classes");

  if (moreClassesButton) {
    moreClassesButton.addEventListener("click", () => {
      if (isMobile) {
        document
          .querySelector(".cart-products-wrapper")
          .classList.add("active");
        document.querySelector(".cart-products").style.flexWrap = "wrap";
        document.querySelector(".mobile-info-wrapper").classList.add("active");
        // Disable body scroll while mobile cart overlay is active
        document.body.style.overflow = "hidden";
      }
      moreClassesButton.style.display = "none";
      window.isMoreClassesShown = true;
      const cartProducts = document.querySelectorAll(".cart-product");
      cartProducts.forEach((product) => {
        product.style.display = "flex";
      });
      // Ensure slider arrows are shown/enabled after revealing all items
      recalcDevCartSlider();
      const visibleAfterShowMore = Array.from(
        document.querySelectorAll(".cart-product")
      ).filter((p) => p.style.display !== "none");
      if (!isMobile && visibleAfterShowMore.length > 3) {
        rightArrow.style.display = "flex";
        leftArrow.style.display = "flex";
      }
    });
  }
}

document.addEventListener("DOMContentLoaded", function () {
  function updateCartProducts(
    details = { productAdded: "", productsAdded: [] }
  ) {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        console.log("cart", cart);
        const cartProductsContainer = document.querySelector(".cart-products");
        cartProductsContainer.innerHTML = "";
        document.querySelector(".cart-count-badge").textContent =
          cart.item_count;

        renderCartItems(cart, details, cartProductsContainer);
        updateMoreClassesSection(cart);
        updateCartSummary(cart);
        renderMoreClassesMessage(cart);
        updateDiscountDisplay(cart);
        updateEmptyCartMessages(cart, cartProductsContainer);
        // if(!document.querySelector(".dev-featured-collection")){
        //     showMoreClasses(cart);
        // }
        showMoreClasses(cart);
        updateSliderArrows();
        applyCurrentDiscount(cart);
      });
  }

  updateCartProducts();
  recalcDevCartSlider();

  function renderCartItems(cart, details, container) {
    cart.items.forEach((item, index) => {
      const isLastItem = index === cart.items.length - 1;
      let productHTML = null;
      if (document.querySelector(".dev-featured-collection")) {
        productHTML = `
                <div class="cart-product ${
                  details.productAdded == item.variant_id ? "animate" : ""
                }" style="${
          isLastItem ||
          cart.items.length <= 3 ||
          window.isMoreClassesShown ||
          (cart.items.length > 5 && !isMobile)
            ? "display: flex;"
            : "display: none;"
        }">
                <button class="close-btn dev-close-btn" data-variant-id="${
                  item.variant_id
                }">
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <circle cx="20" cy="20" r="20" fill="#F80590"/>
                    <path d="M12.5134 27.4871L27.4875 12.513" stroke="white" stroke-width="3"/>
                    <path d="M27.4872 27.4873L12.5132 12.5133" stroke="white" stroke-width="3"/>
                    </svg>
                </button>
                <div class="product-image">
                    <img src="${item.featured_image.url}" alt="${item.title}" />
                </div>
                <div class="cart-price">${
                  item.final_price != 0
                    ? "$" +
                      (item.final_price / 100).toString().replace(/\.00$/, "")
                    : "Free"
                }</div>
                </div>
            `;
      } else {
        productHTML = `
                <div class="cart-product ${
                  details.productAdded == item.variant_id ? "animate" : ""
                }" style="${
          isLastItem ||
          cart.items.length <= 3 ||
          window.isMoreClassesShown ||
          (cart.items.length > 5 && !isMobile)
            ? "display: flex;"
            : "display: none;"
        }">
                <button class="close-btn" data-variant-id="${item.variant_id}">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.3333 3.74095L12.259 2.66667L7.99999 6.92572L3.74094 2.66667L2.66666 3.74095L6.9257 8L2.66666 12.259L3.74094 13.3333L7.99999 9.07429L12.259 13.3333L13.3333 12.259L9.07428 8L13.3333 3.74095Z" fill="white"/>
                    </svg>
                </button>
                <div class="product-image">
                    <img src="${item.featured_image.url}" alt="${item.title}" />
                </div>
                <div class="cart-price">${
                  item.final_price != 0
                    ? "$" + (item.final_price / 100).toFixed(2)
                    : "Free"
                }</div>
                </div>
            `;
      }
      container.insertAdjacentHTML("afterbegin", productHTML);
      recalcDevCartSlider();
    });
    if (cart.items.length == 5) {
      productsWrapper.style.transform = `translateX(0px)`;
    }
    document.querySelector(
      ".mobile-info-wrapper p"
    ).textContent = `${cart.items.length} classes`;
  }

  function renderMoreClassesMessage(cart) {
    if (!document.querySelector(".dev-featured-collection")) {
      if (
        (cart.items.length >= 3 && cart.items.length < 6 && !isMobile) ||
        (cart.items.length > 3 && isMobile)
      ) {
        const addAClassMessage = `
                    <div class="cart-product-empty">
                        Add a class 
                    </div>
                `;
        document
          .querySelector(".cart-products")
          .insertAdjacentHTML("beforeend", addAClassMessage);
      }
    }
  }

  function updateMoreClassesSection(cart) {
    let moreClassesElement = document.querySelector(".more-classes");
    if (
      (!moreClassesElement &&
        !window.isMoreClassesShown &&
        cart.items.length < 6) ||
      (cart.items.length > 3 && isMobile)
    ) {
      moreClassesElement = document.createElement("div");
      moreClassesElement.classList.add("more-classes");
      moreClassesElement.innerHTML = `
                <div class="backdrop"></div>
                <img src="" alt="more classes" />
                <p>${cart.items.length - 1} more classes</p>
            `;
      moreClassesElement.style.display = "none";
      document
        .querySelector(".cart-products")
        .insertAdjacentElement("afterbegin", moreClassesElement);
    }

    if (
      (cart.items.length > 3 &&
        !window.isMoreClassesShown &&
        cart.items.length < 6) ||
      (cart.items.length > 3 && isMobile)
    ) {
      const hiddenProductImage = cart.items[1].featured_image.url;
      moreClassesElement.querySelector("img").src = hiddenProductImage;
      moreClassesElement.style.display = "flex";
    } else if (!window.isMoreClassesShown && cart.items.length < 6) {
      moreClassesElement.style.display = "none";
    }
  }

  function updateCartSummary(cart) {
    document.querySelector(".cart-total span").textContent = `$${(
      cart.total_price / 100
    ).toFixed(2)}`;
    document.querySelector(".cart-sales span").textContent = `$${(
      cart.original_total_price / 100
    ).toFixed(2)}`;
    console.log("cart.items.length", cart.items.length);
    document.querySelector(
      ".amount-btn"
    ).textContent = `Checkout (${cart.items.length})`;
  }

  function updateDiscountDisplay(cart) {
    const discountPercentage =
      ((cart.original_total_price - cart.total_price) /
        cart.original_total_price) *
      100;
    document.querySelector(".cart-sales").innerHTML = `
            <span>$${(cart.original_total_price / 100).toFixed(2)}</span>
            ${discountPercentage ? discountPercentage.toFixed(0) : "0"}% off
        `;

    setCurrentDiscount(discountPercentage);

    const salesItems = document.querySelectorAll(".sales-item .sales-value");

    if (salesItems.length > 0) {
      // Existing logic for salesItems
      salesItems.forEach((item) => item.classList.remove("active"));

      if (discountPercentage >= 50) {
        salesItems[0].classList.add("active"); // 30% Off
        salesItems[1].classList.add("active"); // 40% Off
        salesItems[2].classList.add("active"); // 50% Off
      } else if (discountPercentage >= 40) {
        salesItems[0].classList.add("active"); // 30% Off
        salesItems[1].classList.add("active"); // 40% Off
      } else if (discountPercentage >= 30) {
        salesItems[0].classList.add("active"); // 30% Off
      }
    } else {
      // New logic for elements with data-discount
      const discountItems = document.querySelectorAll(".sales-inner-2-item");
      discountItems.forEach((item) => item.classList.remove("active"));

      discountItems.forEach((item) => {
        const discount = parseInt(item.getAttribute("data-discount"), 10);
        if (
          (discountPercentage >= 50 && discount === 50) ||
          (discountPercentage == 40 && discount === 40) ||
          (discountPercentage == 30 && discount === 30)
        ) {
          item.classList.add("active");
        }
      });
    }
  }

  function updateEmptyCartMessages(cart, container) {
    if (cart.items.length === 0) {
      container.insertAdjacentHTML(
        "beforeend",
        '<div class="cart-product-empty">Add a class to unlock 30% savings</div>'
      );
      container.insertAdjacentHTML(
        "beforeend",
        '<div class="cart-product-empty">Add a class to unlock 40% savings</div>'
      );
      container.insertAdjacentHTML(
        "beforeend",
        '<div class="cart-product-empty">Add a class to unlock 50% savings</div>'
      );
    } else if (cart.items.length === 1) {
      container.insertAdjacentHTML(
        "beforeend",
        '<div class="cart-product-empty">Add a class to unlock 40% savings</div>'
      );
      container.insertAdjacentHTML(
        "beforeend",
        '<div class="cart-product-empty">Add a class to unlock 50% savings</div>'
      );
    } else if (cart.items.length === 2) {
      container.insertAdjacentHTML(
        "beforeend",
        '<div class="cart-product-empty">Add a class to unlock 50% savings</div>'
      );
    }
  }

  document.addEventListener("cartUpdated", (e) => updateCartProducts(e.detail));
});

document.addEventListener("click", function (event) {
  if (event.target.closest(".close-btn")) {
    const variantId = event.target
      .closest(".close-btn")
      .getAttribute("data-variant-id");
    const productCard = document.querySelector(
      `.product-card[data-variant-id="${variantId}"]`
    );
    if (productCard) {
      productCard.classList.remove("active");
      const addButton = productCard.querySelector(".add-btn");
      if (addButton) {
        addButton.classList.remove("rotated");
      }
    }
    animateAndRemoveProduct(variantId);
    deleteProductCard(variantId);
  }
});

addListenerToAddButtons();

function getProductMode() {
  return localStorage.getItem("productMode");
}

function setCurrentDiscount(discount) {
  localStorage.setItem("currentDiscount", discount);
}

function getCurrentDiscount() {
  const currentDiscount = localStorage.getItem("currentDiscount");
  if (isNaN(currentDiscount)) {
    return 30;
  } else if (currentDiscount == 30) {
    return 40;
  } else if (currentDiscount == 40) {
    return 50;
  } else if (currentDiscount == 50) {
    return 50;
  }
  return 30;
}

function getPreviousDiscount() {
  const previousDiscount = localStorage.getItem("currentDiscount");
  if (isNaN(previousDiscount)) {
    return 0;
  } else {
    return previousDiscount;
  }
}

function applyCurrentDiscount() {
  const discount = getCurrentDiscount();
  if (!discount) return;

  if (getProductMode() == "discounted") {
    document.querySelectorAll(".product-card").forEach((card) => {
      const priceElement = card.querySelector(".product-price-current");
      card.querySelector(".product-price-sale").textContent = card.getAttribute(
        "data-original-price"
      );
      if (card.classList.contains("active")) {
        card.querySelector(".product-price-sale").textContent = "";
      }
      if (priceElement) {
        const originalPrice = parseFloat(
          card.getAttribute("data-original-price").replace("$", "")
        );
        const discountedPrice = (originalPrice * (100 - discount)) / 100;
        priceElement.textContent = `$${discountedPrice.toFixed(2)}`;
        if (card.classList.contains("active")) {
          if (document.querySelector(".dev-featured-collection")) {
            priceElement.innerHTMl =
              "<div class='product-price-current--added'>Added to cart</div>";
            card.querySelector(".product-bottom").style.justifyContent =
              "center";
          } else {
            priceElement.textContent = "In Cart";
          }
        }
      }
    });
  } else if (getProductMode() == "cart_discounted") {
    document.querySelectorAll(".product-card").forEach((card) => {
      const priceElement = card.querySelector(".product-price-current");
      const cartTotal = document.querySelector(".cart-sales span").textContent;
      card.querySelector(".product-price-sale").textContent = card.getAttribute(
        "data-original-price"
      );
      if (card.classList.contains("active")) {
        card.querySelector(".product-price-sale").textContent = "";
      }
      if (priceElement) {
        const originalPrice = parseFloat(
          card.getAttribute("data-original-price").replace("$", "")
        );
        const discountedPrice =
          ((parseFloat(cartTotal.replace("$", "")) + originalPrice) *
            (100 - discount)) /
            100 -
          parseFloat(
            (cartTotal.replace("$", "") * (100 - getPreviousDiscount())) / 100
          );
        priceElement.textContent = `${
          discountedPrice.toFixed(2) > 0
            ? "$" + discountedPrice.toFixed(2)
            : "Free"
        }`;
        if (card.classList.contains("active")) {
          if (document.querySelector(".dev-featured-collection")) {
            priceElement.innerHTMl =
              "<div class='product-price-current--added'>Added to cart</div>";
            card.querySelector(".product-bottom").style.justifyContent =
              "center";
          } else {
            priceElement.textContent = "In Cart";
          }
        }
      }
    });
  }
  document.querySelectorAll(".product-card").forEach((card) => {
    if (card.classList.contains("active")) {
      card.querySelector(".product-price-sale").textContent = "";

      if (document.querySelector(".dev-featured-collection")) {
        card.querySelector(".product-price-current").innerHTML =
          "<div class='product-price-current--added'>Added to cart</div>";
        card.querySelector(".product-bottom").style.justifyContent = "center";
      } else {
        card.querySelector(".product-price-current").textContent = "In Cart";
      }
    } else if (
      !card.classList.contains("active") &&
      getProductMode() == "regular"
    ) {
      card.querySelector(".product-price-current").textContent =
        card.getAttribute("data-original-price");
      card.querySelector(".product-price-sale").textContent = card.getAttribute(
        "data-original-compare-price"
      );
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  const urlParams = new URLSearchParams(window.location.search);
  const clsParams = urlParams.getAll("cls");
  console.log("clsParams", clsParams);
  addMultipleProductsToCart(clsParams);

  function checkAndSaveProductMode() {
    const urlParams = new URLSearchParams(window.location.search);
    let productMode = urlParams.get("product_mode");
    if (productMode == null) {
      productMode = "regular";
    }
    if (
      productMode == "discounted" ||
      productMode == "regular" ||
      productMode == "cart_discounted"
    ) {
      localStorage.setItem("productMode", productMode);
    }
    applyCurrentDiscount();
  }

  checkAndSaveProductMode();

  if (clsParams.length > 0) {
    clsParams.forEach((variantId) => {
      const productCard = document.querySelector(
        `.product-card[data-variant-id="${variantId}"]`
      );
      if (productCard) {
        productCard.classList.add("active");
        const addButton = productCard.querySelector(".add-btn");
        if (addButton) {
          addButton.classList.add("rotated");
        }
      }
    });
    const url = new URL(window.location);
    url.searchParams.delete("cls");
    console.log("url", url);
    window.history.replaceState({}, "", url);
  }
});

function applyProductBadge() {
  const productBadge = localStorage.getItem("productBadge");
  if (productBadge == "enabled") {
    document.querySelectorAll(".product-badge").forEach((badge) => {
      badge.style.display = "flex";
    });
  } else {
    document.querySelectorAll(".product-badge").forEach((badge) => {
      badge.style.display = "none";
    });
  }
}

function initializeExperiment() {
  if (typeof posthog !== "undefined") {
    // PostHog is loaded, now we can use onFeatureFlags
    posthog.onFeatureFlags(function () {
      const discountConfig = posthog.getFeatureFlag("bfcm-cart-discount");
      const productBadgeConfig = posthog.getFeatureFlag("bfcm-callout");

      if (discountConfig) {
        localStorage.setItem("productMode", "cart_discounted");
      } else {
        localStorage.setItem("productMode", "regular");
      }

      if (productBadgeConfig) {
        localStorage.setItem("productBadge", "enabled");
      } else {
        localStorage.setItem("productBadge", "disabled");
      }

      applyCurrentDiscount();
      applyProductBadge();
    });
  } else {
    // If PostHog isn't loaded yet, wait and try again
    setTimeout(initializeExperiment, 100);
  }
}

function showDiscountedPrices(config) {
  console.log("Showing discounted prices - user is in test group", config);
}

function showRetailPrices() {
  console.log("Showing retail prices - user is in control group");
}

// Start the initialization process
initializeExperiment();
